import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]

import { ref, reactive, computed } from 'vue';
import { useSdkStore } from '@/stores/sdk'


export default /*@__PURE__*/_defineComponent({
  __name: 'elmentItem',
  props: {
    template: {}
  },
  setup(__props: any) {

const sdkStore = useSdkStore()

const desginsdk = sdkStore.getSdk()
const props = __props

// 计算属性：判断是否为SVG预览
const isSvgPreview = computed(() => {
    if (!props.template?.previewUrl) return false;
    const url = props.template.previewUrl.toLowerCase();
    return url.endsWith('.svg') || url.includes('.svg?') || url.includes('format=svg');
});
const useTemplate = async () => {
    let templates = props.template.fileUrl.split(',')
    for (let i = 0; i < templates.length; i++) {
        await useMaterialTemplate(templates[i])
    }
}

const useMaterialTemplate = async (item) => {
    const fileSuffix = item.split('.').pop()
    if (['jpg', 'jpeg', 'png', 'webp'].includes(fileSuffix)) {
        desginsdk.addElement.createImageElement(item)
        return
    }
    desginsdk.designOpt.requireFile(item)

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "template-item",
    onClick: useTemplate
  }, [
    (!isSvgPreview.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: __props.template.previewUrl + '?x-oss-process=image/resize,w_800/quality,q_80/format,webp',
          alt: "",
          class: "template-image"
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: __props.template.previewUrl,
          alt: "",
          class: "template-image svg-preview"
        }, null, 8, _hoisted_2))
  ]))
}
}

})